import { ItineraryDrawer } from '../../composites/ItineraryDrawer';
import type { ItineraryDrawerTemplateProps } from './ItineraryDrawerTemplate.types';

export function ItineraryDrawerTemplate(props: ItineraryDrawerTemplateProps) {
  return <ItineraryDrawer {...props} />;
}
